class LiveClock {
  constructor() {
    setInterval(this.updateClock, 1000);
  }

  updateClock() {
    const timeOptions = {
      hour: 'numeric', minute: 'numeric', second: 'numeric',
    };
    const dateOptions = {
      month: 'long', weekday: 'short', day: 'numeric',
    };

    const timeFormatter = new Intl.DateTimeFormat([], timeOptions);

    const dateFormatter = new Intl.DateTimeFormat(['en-US'], dateOptions);

    $('#live_time').html(timeFormatter.format(new Date()));
    $('#live_date').html(`${dateFormatter.format(new Date())}th`);
  }
}

export default LiveClock;
